import React, { useState } from "react";
import "./ContactDetails.css";
import { FaInstagram, FaTwitter, FaDiscord, FaYoutube, FaLinkedin, FaGithub, FaSpotify, FaFacebook } from "react-icons/fa";
import { useTranslation } from "../i18n";

const BACKEND_URL = "https://theqahubweb-production.up.railway.app"; 

function ContactDetails() {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ name: "", email: "", message: "" });
    const [error, setError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!validateEmail(formData.email)) {
            setError(t("contact.invalidEmail"));
            setSuccessMessage("");  // Asegurarse de limpiar el mensaje de éxito si hay error
            console.log("Error:", t("contact.invalidEmail"));
            return;
        }
    
        try {
            const response = await fetch(BACKEND_URL + "/api/contact", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });
    
            if (response.ok) {
                setSuccessMessage(t("contact.success"));
                setError(""); // Limpia cualquier error anterior
                setFormData({ name: "", email: "", message: "" });
                console.log("Success:", t("contact.success"));
            } else {
                setError(t("contact.sendError"));
                setSuccessMessage("");
                console.log("Error:", t("contact.sendError"));
            }
        } catch (error) {
            setError(t("contact.connectionError"));
            setSuccessMessage("");
            console.log("Error:", t("contact.connectionError"));
        }
    };    

    return (
        <section id="contact-form" className="contact-section">
            <h2 className="contact-title">{t("contact.title")}</h2>
            <p className="contact-intro">
                {t("contact.intro")}
            </p>
            <section className="contact-container">
                {/* Columna izquierda - Formulario */}
                <div className="contact-form">
                    <h2>{t("contact.formTitle")}</h2>
                    <p>{t("contact.formText")}</p>
                    
                    {error && <p className="error-message">{error}</p>}
                    {successMessage && <p className="success-message">{successMessage}</p>}

                    <form onSubmit={handleSubmit}>
                        <label>{t("contact.name")}</label>
                        <input type="text" name="name" value={formData.name} onChange={handleChange} required />
                        
                        <label>{t("contact.emailLabel")}</label>
                        <input type="email" name="email" value={formData.email} onChange={handleChange} required />
                        
                        <label>{t("contact.message")}</label>
                        <textarea className="message-text" name="message" value={formData.message} onChange={handleChange} required></textarea>
                        
                        <button type="submit">{t("common.sendingMessage")}</button>
                    </form>
                </div>

                {/* Columna derecha - Información y redes sociales */}
                <div className="contact-info">
                    <h2>{t("contact.methodsTitle")}</h2>
                    <p>
                        {t("contact.methodsP1")}
                    </p>

                    <p>
                        {t("contact.methodsP2")}
                    </p>

                    <p>
                        {t("contact.methodsP3")} <a href="mailto:diego.sanchez@theqahub.es"><strong>diego.sanchez@theqahub.es</strong></a>. {t("contact.methodsP4")}
                    </p>


                    <p>{t("contact.socials")}</p>

                    <div className="social-icons-contact">
                        <a href="https://www.instagram.com/theqahub_es/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
                        <a href="https://x.com/theqahub" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
                        <a href="https://discord.gg/Yt4hNswy" target="_blank" rel="noopener noreferrer"><FaDiscord /></a>
                        <a href="https://open.spotify.com/user/314bp5bzxts6pw4hb3xfiyryway4" target="_blank" rel="noopener noreferrer"><FaSpotify /></a>
                        <a href="https://www.tiktok.com/@theqahub" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
                        <a href="https://www.linkedin.com/in/diegosanchezmartin/" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
                        <a href="https://www.facebook.com/theqahub.es" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
                        <a href="https://github.com/theqahub" target="_blank" rel="noopener noreferrer"><FaGithub /></a>
                    </div>
                </div>
            </section>
        </section>
    );
}

export default ContactDetails;
